<template>
    <div>
        <el-card>
            <el-row>
                <el-col :span="24">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item>知识百科</el-breadcrumb-item>
                        <el-breadcrumb-item>销售锦囊</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
            </el-row> 
            <el-divider></el-divider>
            <el-row>
                <div style='float:left;margin-bottom:20px;'>
                    <el-tag :effect="isStaff?'dark':'light'" class="margin-right" @click="staff">员工手册</el-tag>
                    <el-tag :effect="isProduct?'dark':'light'" class="margin-right" type="warning" @click="product">产品手册</el-tag>
                    <el-tag :effect="isQuestion?'dark':'light'" class="margin-right" type="danger" @click="question">问题答疑</el-tag>
                </div>
            </el-row>
            <el-row>
                <el-col :span="18">
                    <!-- 员工手册/问题答疑 -->
                    <div :class="isStaff?'main show':(isQuestion?'main show':'main hidden')" v-loading="loading">
                        <div class="staff_table" v-for="(item,index) in treeData" :key="item.id" >
                            <div :class="index%2==0?'table_head':'table_head table_color'" >{{item.name}}</div>
                            <div class="table_main">
                                <div class="table_row" v-for="nodeItem in item.children" :key="nodeItem.id" >
                                    <div class="main_title">{{nodeItem.name}}</div>
                                    <div class="main_list">
                                        <ul class="ul">
                                            <li class="li" v-for="wikiItem in nodeItem.children" :key="wikiItem.id" ><a @click="bindWiki(wikiItem.id)">{{wikiItem.name}}</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 产品列表 -->
                    <div :class="isProduct?'main show':'main hidden'" v-loading="loading">
                        <el-col :span="12" style="font-size:12px;"  v-for="(item,index) in treeData" :key="item.id">
                            <div :class="index%2==0?'table_1_product':(index%3==0?'table_3_product':'table_2_product')" >
                                <div class="table-content_product">
                                    <div class="table_title_product">{{item.name}}</div>
                                    <div class="table_main_product">
                                        <div class="table_col_product" v-for="nodeItem in item.children" :key="nodeItem.id">
                                            <div class="main_title_product">{{nodeItem.name}}</div>
                                            <div class="main_list_product">
                                                <ul class="ul_product">
                                                    <li class="li_product" v-for="wikiItem in nodeItem.children" :key="wikiItem.id" ><a @click="bindWiki(wikiItem.id)">{{wikiItem.name}}</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                    </div>
                    <!-- 饼壮图 -->
                    <!-- <div :class="isCompass?'main show':'main hidden'" id="user">
                        <div id="main1" style="float:left;width:100%;height:1024px;"></div>
                    </div> -->
                </el-col>
                <!-- 右边热门菜单 -->
                <el-col style="font-size:12px;" :span="6">
                    <el-col :span="14"  class="hot_title">
                        <el-input size="small" v-model="title" placeholder="请输入搜索内容">
                            <el-button slot="append" icon="el-icon-search" @click="SearchByName"></el-button>
                        </el-input>
                        <div class="hot_list">
                            <h1 style="float:left;">{{hotTitle}}</h1>
                            <ul style="float:left;font-size:12px;" :class="hotTitle=='搜索结果'?'ul_hot hidden':'ul_hot show'">
                                <li class="li_hot" style="text-align:left;" v-for="item in hotTreeData" :key="item.KnowledgeID">
                                    <a style="margin-right:5px;" @click="bindWiki(item.KnowledgeID)">{{item.KnowledgeTitle}}</a>
                                    <el-tag v-if="item.KnowledgeNodeName" size="mini" effect="dark" type="info">{{item.KnowledgeNodeName}}</el-tag></li>
                            </ul>
                            <ul style="float:left;font-size:12px;" :class="hotTitle=='搜索结果'?'ul_hot show':'ul_hot hidden'">
                                <li class="li_hot" style="text-align:left;" v-for="item in hotTreeData" :key="item.ArtcleId">
                                    <a style="margin-right:5px;" @click="bindWiki(item.ArtcleId)">{{item.ArticleName}}</a>
                                    <el-tag v-if="item.NodeTitle" size="mini" effect="dark" type="info">{{item.NodeTitle}}</el-tag></li>
                            </ul>
                        </div>
                        
                    </el-col>
                    <el-col :span="5" style="margin-top:5px;">
                        <el-button style="float:right;" size="small" @click="clearAll" >清空</el-button>
                    </el-col>
                </el-col>
            </el-row>
        </el-card>
    </div>
</template>
<script>
import { GetTreeBySales,GetHotKnowledgeList,GetHotSearchKnowledgeList } from "../../until/ZeusApiSDK/Logic/WikiLogic";
export default {
    data() {
        return{
            nodeId:'F858E04A-0C96-4AC7-A4BA-7CC931B24217',//节点id 默认员工手册
            type:0,//类型
            treeData:[],//树状结构
            isStaff:true,//是否显示员工
            isProduct:false,//是否显示产品
            isQuestion:false,//是否显示问题答疑
            title:'',//搜索内容
            hotTreeData:[],//热门列表数据
            hotTitle:'热门百科',//热门搜索头部标题 
            loading:true
        };
    },
    created() {
        //获取树状结构数据
        this.GetTreeBySales();
        //获取热门列表
        this.GetHotKnowledgeList();
    },
    // mounted(){
    //     //加载饼状图数据
    //     this.initData();
    // },
    methods: {
        //获取销售锦囊树状结构
        GetTreeBySales:function(){
            this.treeData=[];
            //获取数据
            GetTreeBySales(this.nodeId,this.type).then(res=>{
                this.loading=false;
                if(res.length>0){
                    this.treeData=res[0].children;
                }
            });
        },
        //员工手册点击
        staff:function(){
            this.nodeId="F858E04A-0C96-4AC7-A4BA-7CC931B24217";
            this.type=0;
            this.isStaff=true;
            this.isProduct=false;
            this.isQuestion=false;
            //重新加载数据
            this.GetTreeBySales();
        },
        //产品手册点击
        product:function(){
            this.nodeId="A3B56A05-F8AB-4C51-8AF8-1AD0798A0C4A";
            this.type=1;
            this.isStaff=false;
            this.isProduct=true;
            this.isQuestion=false;
            //重新加载数据
            this.GetTreeBySales();
        },
        //问题答疑点击
        question:function(){
            this.nodeId="5D6289B7-4B0E-4061-AE44-FC4908416D32";
            this.type=2;
            this.isStaff=false;
            this.isProduct=false;
            this.isQuestion=true;
            //重新加载数据
            this.GetTreeBySales();
        },
        //查看详情
        bindWiki:function(id){
            //跳转到查看详情页面
            this.$router.push('/wiki/BindWiki?id='+id+'&name=销售锦囊');
        },
        //获取热门列表
        GetHotKnowledgeList:function(){
            GetHotKnowledgeList(18).then(res=>{
                this.hotTreeData=res;
            });
        },
        //获取搜索数据
        SearchByName:function(){
            this.hotTitle="搜索结果";
            //获取热门列表
            GetHotSearchKnowledgeList(this.title).then(res=>{
                this.hotTreeData=res;
            });
        },
        //清空搜索
        clearAll:function(){
            this.title='';
            this.hotTitle="热门百科";
            //获取热门列表
            this.GetHotKnowledgeList();
        },
    }
}
</script>
<style lang="less" scoped>
a,a:hover {
    text-decoration:none;
    
}
body{
    background-color: #eeeeee;
}
.ul {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    flex-wrap: wrap;
    padding: 2px;
}
.ul .li {
    list-style: none;
    width: 30%;
    height: 100%;
    padding: 4px;
    font-size: 14px;
}

.ul .li a {
    color: #555555;
    padding: 2px;
}
.table_1,.table_2,.table_3 {
    margin-top: 20px;
    width: 100%;
    height: 303px;
    box-shadow:0 0 5px #ccc;
}
.table_2 .table_head{
    background-color: #56c4ce;
}
.table_head {
    position: relative;
    overflow: hidden;
    height: auto;
    width: 5%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #5f7bc9;
    writing-mode: vertical-rl;
    text-align: center;
    font-family: 微软雅黑;
    font-size: 20px;
    color: #fff;
    font-weight: bold;
    padding:5px;
}
.table_main{
    width: 95%;
    height: 100%;
    float: left;
}
.table_row {
    display: flex;
    align-items: center;
    padding: 2px;
}

.table_row:nth-child(2n+1) {
    background: #f1f3f7;
}
.main_title {
    height: 100%;
    width: 18.7%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
    padding: 2px;
}
.main_list {
    width: 81.3%;
    height: 100%;
    background-color: #fff;
    padding: 2px;
}

.staff_table {
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    margin-top: 5px;
    width: 100%;
    height: auto;
    box-shadow: 0 0 5px #ccc;
    background: #f8f9fb;
    padding: 2px;
}
.table_color{
    background-color: #56c4ce;
}
.margin-right{margin-right:8px;}

.ul_product .li_product {
    list-style: none;
    padding:4px;
}
.ul_product .li_product a {
    color: #555555;
    font-size:14px;
}
.main_list_product{
    display: flex;
    align-items: center;
    font-size: 16px;
    padding: 15px 0 20px 15px;
}
.main_product{
    column-count: 2;
    column-gap: 0;
    margin: 15px;
}
.table_1_product,.table_2_product,.table_3_product {
    box-sizing: border-box;
    break-inside: avoid;
    /* padding: 10px; */
    padding-right: 15px;
    margin-bottom: 15px;
    width: 100%;
}
.table-content_product {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* padding: 10px; */
    height: auto;
    width: 100%;
    font-size: 20px;
    color: #686868;
    box-sizing: border-box;
    box-shadow:0 0 5px #ccc;
    /* border: 1px solid #ccc; */
}
.table_title_product{
    background-color: #dfdfdf;
    border-bottom: 5px solid #cecece;
    color: #444444;
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight:bold;
    font-size: 16px;
}
.table_main_product{
    width: 100%;
}
.table_col_product{
    width: 33.33%;
    float: left;
}
.table_main_product{
    margin-top: 5px;
}
.main_title_product{
    background-color: #6282d2;
    color: #fff;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight:bold;
    font-size: 14px;
}
.table_col_product:nth-of-type(3n+1) {
    clear: both;
}
.table_1_product .table_col_product:nth-of-type(3n+1) .main_title_product{
    background: #6282d2 !important;
}
.table_1_product .table_col_product:nth-of-type(3n+2) .main_title_product{
    background: #6298c5 !important;
}
.table_1_product .table_col_product:nth-of-type(3n) .main_title_product{
    background: #6daec6 !important;
}
.table_2_product .table_col_product:nth-of-type(3n+1) .main_title_product{
    background: #6ab3c3 !important;
}
.table_2_product .table_col_product:nth-of-type(3n+2) .main_title_product{
    background: #aec96e !important;
}
.table_2_product .table_col_product:nth-of-type(3n+3) .main_title_product{
    background: #e5bd60 !important;
}
.table_3_product .table_col:nth-of-type(3n+1) .main_title_product{
    background: #9385d3 !important;
}
.table_3_product .table_col_product:nth-of-type(3n+2) .main_title_product{
    background: #817acb !important;
}
.table_3_product .table_col_product:nth-of-type(3n+3) .main_title_product{
    background: #9385d3 !important;
}
.hot_title{
    margin-left:26px;
    margin-top:5px;
}
.hot_list{
    float:left;
    margin-top:16px;
}
.ul_hot .li_hot {
    list-style: none;
    padding:6px;
    width:100%;
}
.ul_hot .li_hot a {
    color: #555555;
    font-size:14px;
}
.show{
    display: block;
}
.hidden{
    display: none;;
}
</style>